module.exports = __webpack_public_path__ + "img/UpDayCIC_clicked.86c9d9a1.svg";